var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-loader":"","aria-busy":"true"}},[_c('div',{attrs:{"data-balls":""}},[_c('span',{attrs:{"data-ball1":""}}),_c('span',{attrs:{"data-ball2":""}}),_c('span',{attrs:{"data-ball3":""}})])])
}]

export { render, staticRenderFns }